import { orpcSuccessVoidResponseSchema } from "./util/success.mjs";
import { oc } from "@orpc/contract";
//#region src/api/orpc/ssr.ts
const ssrContract = oc.prefix("/ssr").tag("SSR").router({ clearExperimentCache: oc.route({
	summary: "Clear SSR experiment cache for the current user",
	description: "Deletes the cached SSR experiment variant for the authenticated user, forcing a fresh lookup on next request.",
	method: "GET",
	path: "/experiment-cache"
}).output(orpcSuccessVoidResponseSchema).errors({ UNAUTHORIZED: {
	status: 401,
	message: "Authentication required"
} }) });
//#endregion
export { ssrContract };
